import {join} from 'lodash';
import {isNullOrUndefined} from 'util';
import {Pipe, PipeTransform} from '@angular/core';
import {Share} from '../api/entity/share.model';
import {MoneyPipe} from '../../pipes/money.pipe';
import {SharePreset} from '../api/entity/share-preset.model';

@Pipe({name: 'tflShare'})
export class SharePipe implements PipeTransform {

    constructor(private _moneyPipe: MoneyPipe) {
    }

    transform(value: any | Share | SharePreset, ...args: any[]): any {
        if (isNullOrUndefined(value)) {
            return '';
        }
        let percentStr = isNullOrUndefined(value.percent) ? null : value.percent + '%';
        let amountStr = isNullOrUndefined(value.amount) ? null : this._moneyPipe.transform(value.amount);
        return join([amountStr, percentStr].filter(str => !isNullOrUndefined(str)), '/');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/rules/share.pipe.ts